"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _textInfo = _interopRequireDefault(require("@mui-treasury/components/content/textInfo"));

var TextInfo = function TextInfo(_ref) {
  var body = _ref.body,
      heading = _ref.heading,
      overline = _ref.overline,
      classes = _ref.classes,
      storyblokClass = _ref.storyblokClass,
      dataBlokC = _ref.dataBlokC,
      dataBlokUid = _ref.dataBlokUid;
  return /*#__PURE__*/_react.default.createElement(_textInfo.default, {
    overline: overline,
    heading: heading,
    body: body,
    className: storyblokClass,
    classes: classes,
    "data-blok-c": dataBlokC,
    "data-blok-uid": dataBlokUid
  });
};

var _default = TextInfo;
exports.default = _default;
TextInfo.propTypes = {
  classes: _propTypes.default.shape(),
  overline: _propTypes.default.string.isRequired,
  heading: _propTypes.default.string.isRequired,
  body: _propTypes.default.string.isRequired,
  dataBlokC: _propTypes.default.string,
  dataBlokUid: _propTypes.default.string,
  storyblokClass: _propTypes.default.string
};
TextInfo.defaultProps = {
  classes: {},
  dataBlokC: '',
  dataBlokUid: '',
  storyblokClass: ''
};